import React, { Component } from "react";
import {getTimeInIST, format_fancy} from '../Utils'
import moment from 'moment';
import { withStyles, Grid, Table, TableBody, FormControl, TablePagination } from "@material-ui/core";
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import Paper from '@material-ui/core/Paper';
import { ReportService } from "../Services/ReportService";
import AutoCompleteSelection from "../components/AutoCompleteSelection_v2";
import EnhancedTableToolbar from "../components/EnhancedTableToolbar";
import EnhancedTableHead from "../components/EnhancedTableHead";
import { RowCountOptions } from "../Config";

const styles = theme =>({
    fab: {
        margin: theme.spacing(1),
    },
    root: {
      width: '100%',
      marginTop: theme.spacing(3)
    },
    tablecell: {
        fontSize: '30pt',
        padding: 2
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(4),
        width: "80%",
        outline: 'none',
        textAlign: 'center',
        color: theme.palette.text.secondary,
        marginBottom : '20px',
    },
    formControl: {
        margin: theme.spacing(1),
        marginTop: theme.spacing(2),
        minWidth: 200,
        marginLeft: theme.spacing(2),
        [theme.breakpoints.up('md')]: {
            marginLeft: theme.spacing(1),
        },
        float: 'left'
    },
    section: {
		width: '100%',
		minHeight: 400,
		overflow: 'auto',
		overflowX: 'auto',
		paddingTop : theme.spacing(1), 
		paddingLeft: theme.spacing(1), 
		paddingRight: theme.spacing(1),
		paddingBottom: theme.spacing(1)
    },
    table: {
        height: 300,
        overflow: 'auto'
    }, 
    selectRoot: {
        [theme.breakpoints.down('md')]: {
            marginLeft: 0,
            marginRight: 0
        },
    },
  });

class ActivityTracking extends Component {

    constructor(props) {
      super(props);
      this.state = {       
        startDate: moment(),
        endDate: moment(),
        activity_rows: [],
        selected_action: '-1',
        selected_object: '-1',
        actions: [],
        objects: [],
        numItemsPerPage: 10,
        currentPageNumber: 0,
        totalItems: 0,
        totalPages: 0,
        columns : [
            { id: 'sl_no', numeric: false, disablePadding: false, label: 'Sl.no', sortable: false },
            { id: 'action', numeric: false, disablePadding: false, label: 'Action' , sortable: true },
            { id: 'object', numeric: false, disablePadding: false, label: 'Object' , sortable: true },
            { id: 'object_id', numeric: false, disablePadding: false, label: 'Identifier', sortable: true  },
            { id: 'description', numeric: false, disablePadding: false, label: 'Description', sortable: false  },
            { id: 'action_by', numeric: false, disablePadding: false, label: 'Performed By', sortable: true  },
            { id: 'modified_date', numeric: false, disablePadding: false, label: 'Modified Date' , sortable: true },
        ],
        order: 'desc',
        orderBy: 'modified_date',
        filter: ''
      }
    }

    componentDidMount(){
        this.props.setTitle('Activity Tracking');
        this.fetchActionsAndObjects();
        this.props.isLoading(false);
        this.fetchTotalPages();
    }

    fetchTotalPages(){
        this.props.isLoading(true);
        let {startDate, endDate, filter, selected_action, selected_object} = this.state;
        ReportService.getTotalActivityCount(startDate, endDate, selected_action, selected_object, filter)
        .then((data) => {
            this.setState({
                totalItems: data.count, 
                totalPages: Math.ceil(data.count / this.state.numItemsPerPage) - 1
            });
            this.props.isLoading(false);
            if(data.count > 0) {
                this.fetchData(0, this.state.numItemsPerPage);
            } else {
                this.setState({activity_rows: [], message: "No Activities"});
            }
        })
        .catch(error => {
            this.props.isLoading(false);
            console.log(error);
        });
    }

    fetchActionsAndObjects = () => {
        
        let actions = [
            {
                id: '-1',
                value: '-1', 
                label: 'ALL'
            },
            {
                id: 'ACTION_UPDATE',
                value: 'UPDATE', 
                label: 'UPDATE'
            },
            {
                id: 'ACTION_ADD',
                value: 'ADD', 
                label: 'ADD'
            },
            {
                id: 'ACTION_ADD',
                value: 'REMOVE', 
                label: 'REMOVE'
            }
        ];

        let objects = [
            {
                id: '-1',
                value: '-1', 
                label: 'ALL'
            },
            {
                id: 'OBJECT_AGENT',
                value: 'AGENT', 
                label: 'AGENT'
            },
            {
                id: 'OBJECT_STORE',
                value: 'STORE', 
                label: 'STORE'
            },
            {
                id: 'OBJECT_CUSTOMER',
                value: 'CUSTOMER', 
                label: 'CUSTOMER'
            },
            {
                id: 'OBJECT_PRODUCT',
                value: 'PRODUCT', 
                label: 'PRODUCT'
            },
            {
                id: 'OBJECT_SCHEDULE',
                value: 'SCHEDULE', 
                label: 'SCHEDULE'
            },
            {
                id: 'OBJECT_DELIVERY',
                value: 'DELIVERY', 
                label: 'DELIVERY'
            },
            {
                id: 'OBJECT_APPROVAL',
                value: 'INVOICE', 
                label: 'INVOICE'
            },
            {
                id: 'OBJECT_ROUTE',
                value: 'ROUTE', 
                label: 'ROUTE'
            },
            {
                id: 'OBJECT_ORGANISATION',
                value: 'ORGANISATION', 
                label: 'ORGANISATION'
            },
            {
                id: 'OBJECT_WH_REASON',
                value: 'WAREHOUSE REASON', 
                label: 'WAREHOUSE REASON'
            },
            {
                id: 'OBJECT_WH',
                value: 'WAREHOUSE', 
                label: 'WAREHOUSE'
            },
            {
                id: 'OBJECT_IN',
                value: 'INVENTORY', 
                label: 'INVENTORY'
            },
            {
                id: 'OBJECT_IMPORT',
                value: 'IMPORT', 
                label: 'IMPORT'
            }
        ];
        if(!this.props.modules_enabled.b2c_module) {
            objects = objects.filter(o => o.id !== "OBJECT_CUSTOMER")
        }
        if(!this.props.modules_enabled.b2b_module) {
            objects = objects.filter(o => o.id !== "OBJECT_STORE")
        }
        this.setState({actions, objects});
        
    }

    handleChangeStartDate = (date) => {
        this.setState({
            startDate: date,
        }, () => this.fetchTotalPages());
    }

    handleChangeEndDate = (date) => {
        this.setState({
            endDate: date,
        }, () => this.fetchTotalPages());
    }

    handleActionSelection = (e) => {
        this.setState({selected_action: e.value}, () => this.fetchTotalPages());
    }

    handleObjectSelection = (e) => {
        this.setState({selected_object: e.value}, () => this.fetchTotalPages());
    }

    handleSelect = (eventKey, e) => {
        if(eventKey === 'prev'){
            if((this.state.currentPageNumber) > 0){
                this.fetchRow(this.state.currentPageNumber - 1);
            }
        } else if(eventKey === 'next'){
            if((this.state.currentPageNumber) < this.state.totalPages){
                this.fetchRow(this.state.currentPageNumber + 1);
            }   
        }
    }

    fetchRow = (newCurrentPage) => {
        this.fetchData(newCurrentPage * this.state.numItemsPerPage, this.state.numItemsPerPage);
        this.setState({ currentPageNumber: newCurrentPage });
    }

    sortBy = (event, property) => {
        const orderBy = property;
        let order = 'desc';
    
        if (this.state.orderBy === property && this.state.order === 'desc') {
          order = 'asc';
        }
    
        this.setState({ order, orderBy }, () => this.fetchData(0, this.state.numItemsPerPage));
    }

    handleChangeRowsPerPage = event => {
        this.setState({ numItemsPerPage : event.target.value, currentPageNumber: 0 }, () => this.fetchData(0, this.state.numItemsPerPage));
    }

    handleChangePage = (event, page) => {
        if(this.state.currentPageNumber > page){
            this.fetchRow(this.state.currentPageNumber - 1);
        } else {
            this.fetchRow(this.state.currentPageNumber + 1);
        }
    };

    filterCriteria = (e) => {
        let searchText = "";
        if(e){
            e.preventDefault();
            searchText = e.target.value || "";
        } else {
            searchText = this.state.filter;
        }
        this.setState({filter : searchText}, () => this.fetchData(0, this.state.numItemsPerPage));
    }

    fetchData = (start, numberItems) => {
        let {orderBy, order, selected_action, selected_object, startDate, endDate, filter} = this.state;
        this.props.isLoading(true);
        let activity_rows = [];
        let sort = orderBy ? orderBy : '', direction = order ? order : '';

        ReportService.getActivities(startDate, endDate, selected_action, selected_object, start, numberItems, filter, sort, direction)
        .then((data) => {
            console.log(data);
            if(data.activities){
                data.activities.forEach((activity, index) => {
                    activity_rows.push(<ActivityDetails index={index + 1  + start} key={activity.id} activity={activity} />);
                });
            }
            this.props.isLoading(false);
            this.setState({activity_rows, message: data.activities.length > 0 ? "" : "No Activities"});
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }
    
    render() {
        let { order, orderBy, columns, totalItems, numItemsPerPage, currentPageNumber, startDate, endDate, message, activity_rows, selected_object, selected_action, actions, objects} = this.state;
        const { classes } = this.props;
        return ( 
            <div className="Home" style={{marginTop: 24}}>
                <Grid container spacing={2} style={{marginTop: 20}}>
                    <Grid item xs={12}>
                        <Paper className={classes.root} style={{paddingTop : '15px', paddingLeft: "5px", paddingRight: "5px", marginTop: '10px'}}>
                            <Grid container>
                                <Grid item style={{zIndex: 5}} xs={12}>
                                    <FormControl variant="outlined" className={classes.formControl}>
                                        <AutoCompleteSelection  
                                            placeHolder="Action"
                                            isMulti={false}
                                            onChange={this.handleActionSelection}
                                            value={actions.filter((action) => action.value === selected_action)}
                                            className={this.props.classes.textField}
                                            required={true}
                                            options={actions}/>
                                    </FormControl>
                                    <FormControl variant="outlined" className={classes.formControl}>
                                        <AutoCompleteSelection  
                                            placeHolder="Object"
                                            isMulti={false}
                                            onChange={this.handleObjectSelection}
                                            value={objects.filter((object) => object.value === selected_object)}
                                            className={this.props.classes.textField}
                                            required={true}
                                            options={objects}/>
                                    </FormControl>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <DatePicker
                                            variant="dialog"
                                            margin="normal"
                                            label="From"
                                            value={startDate}
                                            onChange={this.handleChangeStartDate}
                                            format='DD MMM YYYY'
                                            maxDate={endDate}
                                            inputVariant="outlined"
                                            className={classes.formControl}
                                            style={{ height: "100%", marginTop: "24px"}}
                                        />
                                        <DatePicker
                                            variant="dialog"
                                            margin="normal"
                                            label="To"
                                            value={endDate}
                                            minDate={startDate}
                                            onChange={this.handleChangeEndDate}
                                            format='DD MMM YYYY'
                                            inputVariant="outlined"
                                            className={classes.formControl}
                                            style={{ height: "100%", marginTop: "24px"}}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item xs={12}>
                                    <EnhancedTableToolbar  onSearchTextChange={this.filterCriteria} searchText={this.state.filter}/>
                                        <Table padding="none" size="small" style={{maxHeight: 500}}>
                                            <EnhancedTableHead
                                                order={order}
                                                orderBy={orderBy}
                                                onRequestSort={this.sortBy}
                                                rows ={columns} />
                                            <TableBody>
                                            {activity_rows}
                                            </TableBody>
                                        </Table>
                                        { message &&
                                            <div style={{backgroundColor: 'white', color:"red", paddingTop:50}}>{message}</div>
                                        }
                                        <TablePagination
                                            rowsPerPageOptions={RowCountOptions}
                                            component="div"
                                            count={totalItems}
                                            rowsPerPage={numItemsPerPage}
                                            page={currentPageNumber}
                                            backIconButtonProps={{
                                                'aria-label': 'Previous Page',
                                            }}
                                            nextIconButtonProps={{
                                                'aria-label': 'Next Page',
                                            }}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                            classes={{ selectRoot : classes.selectRoot}}
                                            />
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

function ActivityDetails(props){

    const {activity, index} = props;

    let color = 'blue';
    switch(activity.action){
        case 'REMOVE': color = 'red'; break;
        case 'UPDATE': color = 'green'; break;
        case 'ADD': default: color = 'blue'; break;
    }
    
    const classes = {
        tablecell: {
            fontSize: '10pt',
            padding: 2
        },
        tablecellAction: {
            fontSize: '10pt',
            padding: 2,
            color: color
        }
    }

    return (
        <tr>
            <td style={classes.tablecell}>{index}</td>
            <td align="justify" style={classes.tablecellAction}>{activity.action}</td>
            <td align="justify" style={classes.tablecell}>{activity.object}</td>
            <td align="justify" style={classes.tablecell}>{activity.object_id ? activity.object_id : '-'}</td>
            <td align="justify" style={classes.tablecell}>{activity.description ? activity.description : '-'}</td>
            <td align="left" style={classes.tablecell}>{activity.action_by ? activity.action_by : '-'}</td>
            <td align="left" style={classes.tablecell}>{getTimeInIST(activity.modified_date).format(format_fancy)}</td>
        </tr>
    );
}

export default withStyles(styles)(ActivityTracking);